/* eslint-disable no-shadow */
import { hideLoader } from "action/loader/hideLoader";
import { showLoader } from "action/loader/showLoader";
import { refreshShoppingCart } from "action/shopping-cart/refreshShoppingCart";
import { copyApi } from "api/shopping-cart/copyApi";
import DocumentMeta from "component/design-system/DocumentMeta";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import { useDispatch } from "react-redux";

interface IProps {
  uuid: string;
}

function ShoppingCartShare({ uuid }: IProps) {
  const [failMessages, setFailMessages] = useState([]);
  const router = useRouter();
  const dispatch = useDispatch();

  useEffect(() => {
  // Prefetch pages for faster client-side transitions
  // https://nextjs.org/docs/api-reference/next/router#routerprefetch
    router.prefetch("/shopping-cart");
    dispatch(showLoader());
    copyApi(uuid)
      .then(({ data }) => {
        if (data.successful) {
          dispatch(refreshShoppingCart());
          dispatch(hideLoader());
          let shoppingCartUrl = "/shopping-cart";
          if (router.query.z_id) {
            shoppingCartUrl += `?z_id=${router.query.z_id}`;
          }
          router.replace(shoppingCartUrl);
        } else {
          setFailMessages(data.failureMessage);
          dispatch(hideLoader());
        }
      });
  }, [uuid]);

  const meta = {
    title: "PartsAvatar.ca: Shared Shopping Cart",
    description: "",
    meta: {
      robots: "noindex, nofollow",
    },
  };

  return (
    <div className="container">

      <DocumentMeta {...meta} />
      {failMessages && failMessages.length > 0 && (
        <div className="alert alert-danger m-t-20" role="alert">
          <ul>
            {[failMessages].map((message, index) => (
              <li key={index}>{message}</li>
            ))}
          </ul>
        </div>
      )}

      <Skeleton height={1000} />
    </div>
  );
}

export default ShoppingCartShare;
